<template>
  <v-layout>
    <v-checkbox
      :label="field.label"
      v-model="$parent.entity[field.name]"
      :disabled="field.disabled"
    >
    </v-checkbox>
  </v-layout>
</template>

<script>
export default {
  name: "CheckboxField",
  props: ["field", "value"]
};
</script>

<style scoped></style>
